import { render, staticRenderFns } from "./ChunkCard.vue?vue&type=template&id=0ae2e4a0&scoped=true&"
import script from "./ChunkCard.vue?vue&type=script&lang=js&"
export * from "./ChunkCard.vue?vue&type=script&lang=js&"
import style0 from "./ChunkCard.vue?vue&type=style&index=0&id=0ae2e4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae2e4a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCard,VRow,VSlideGroup,VSlideItem,VTextField})
